const hectaresToAcres = 2.47105381467165
const sqFtToAcres = 0.000022956841138659
const sqMetersToAcres = 0.000247105381467165

export const convertToAcres = (uom: string, value: number | null) => {
    if (value === null) {
        return null
    }
    const mappings = { "H": hectaresToAcres, "F": sqFtToAcres, "M": sqMetersToAcres }
    if (uom && uom !== "A") {
        return value * mappings[uom as keyof typeof mappings]
    }
    return value
}

const metersToFeet = 3.28083989501312

export const convertToFeet = (uom: string, value: number) => {
    if (uom && uom === "M") {
        return value * metersToFeet
    }
    return value
}

export const calculateHalo = (perimeter: number, uom: string) => {
    if (uom === "M") {
        return perimeter * 5
    } else {
        return perimeter * (5 * metersToFeet)
    }
}